import {useTranslation} from "react-i18next";
import {faChevronDown, faChevronUp, faEnvelope} from "@fortawesome/free-solid-svg-icons";
import {faLinkedin} from "@fortawesome/free-brands-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState} from "react";
import CopyMail from "./common/CopyMail";
import {useIsBiggerThanSize} from "../../sizes/sizes";

const AboutMe = (props:{openModal:()=>any}) => {
    const {t} = useTranslation();
    const isDesktop = useIsBiggerThanSize('lg')
    const [expanded, setExpanded] = useState(false)
    const paragraphs = [t("aboutMe.main.p1"), t("aboutMe.main.p2"), t("aboutMe.main.p3")]
    const visibleParagraphs = !isDesktop && !expanded ? paragraphs.slice(0, 2) : paragraphs

    return (
        <div
            className={"w-full rounded-2xl border border-borderLight dark:border-borderDark " +
                "bg-surfaceLight dark:bg-surfaceDark p-4 shadow-sm lg:p-8"}>
            <div className={"grid grid-cols-[auto_1fr] gap-4 lg:gap-6 " +
                "[grid-template-areas:'photo_head'_'body_body'_'actions_actions'] " +
                "lg:[grid-template-areas:'photo_head'_'photo_body'_'photo_actions']"}>
                <img alt={"Jaime José Corral García"}
                     className={"[grid-area:photo] h-24 w-24 shrink-0 rounded-xl object-cover object-center " +
                         "ring-1 ring-borderLight dark:ring-borderDark lg:h-48 lg:w-48"}
                     src={"/img/fotoSq.png"}/>
                <div className={"min-w-0 [grid-area:head]"}>
                    <h2 className={"text-2xl font-bold tracking-tight lg:text-3xl"}>
                        {t("aboutMe.title")}
                    </h2>
                    <p className={"mt-1 text-sm text-mutedLight dark:text-mutedDark lg:text-base"}>
                        {t("aboutMe.short")}
                    </p>
                </div>
                <div className={"min-w-0 [grid-area:body]"}>
                    <div className={"space-y-2.5 text-base leading-relaxed lg:text-lg"}>
                        {visibleParagraphs.map((x, i) => <p key={i}>{x}</p>)}
                    </div>
                    {!isDesktop &&
                        <button aria-label={expanded ? t("aboutMe.showLess") : t("aboutMe.showMore")}
                                onClick={()=>{setExpanded(!expanded)}}
                                className={"mt-2 inline-flex touch-manipulation cursor-pointer items-center gap-1.5 " +
                                    "text-sm font-semibold text-accent transition-colors hover:text-accentHover"}>
                            {expanded ? t("aboutMe.showLess") : t("aboutMe.showMore")}
                            <FontAwesomeIcon size={"xs"} icon={expanded ? faChevronUp : faChevronDown}/>
                        </button>}
                </div>
                <div className={"[grid-area:actions] mt-2 flex flex-wrap gap-3 lg:mt-6"}>
                    <button
                        className={"rounded-lg bg-accent px-5 py-2.5 text-sm font-semibold text-white " +
                            "transition-colors hover:bg-accentHover active:bg-accentHover"}
                        onClick={()=>{window.open("/CV Jaime José Corral García.pdf", '_blank')}}>
                        {t("aboutMe.downloadCVButton")}
                    </button>
                    <button
                        className={"rounded-lg border border-accent px-5 py-2.5 text-sm font-semibold text-accent " +
                            "transition-colors hover:bg-accentSoft dark:hover:bg-accent/10 " +
                            "active:bg-accentSoft dark:active:bg-accent/10"}
                        onClick={()=>{props.openModal()}}>
                        {t("aboutMe.contactButton")}
                    </button>
                </div>
            </div>
            <div className={"mt-4 flex flex-wrap gap-x-6 gap-y-2 border-t border-borderLight pt-4 " +
                "text-sm dark:border-borderDark lg:text-base"}>
                <div className={"flex items-center gap-2"}>
                    <span className={"text-mutedLight dark:text-mutedDark"}>
                        <FontAwesomeIcon icon={faEnvelope}/>
                    </span>
                    <CopyMail/>
                </div>
                <div onClick={() => {window.open("https://www.linkedin.com/in/jaimejcorral", '_blank')}}
                     className={"flex cursor-pointer items-center gap-2 transition-colors " +
                         "text-accent hover:text-accentHover"}>
                    <span className={"text-mutedLight dark:text-mutedDark"}>
                        <FontAwesomeIcon icon={faLinkedin}/>
                    </span>
                    Jaime José Corral García
                </div>
            </div>
        </div>
    )
}

export default AboutMe
